import { BACKEND_BASE_URL } from "../constants";

export interface BackendResponse<T = any> {
  data: T | null;
  error: any;
}
interface Options {
  method?: "GET" | "POST";
  body?: unknown | ArrayBuffer;
  accessToken?: string | null;
}

export async function backendTransportRequest<T = any>(
  path: string,
  options: Options = {}
): Promise<BackendResponse<T>> {
  const { method = "POST", body, accessToken } = options;
  const binary = body instanceof ArrayBuffer;
  const headers: Record<string, string> = {};
  if (method !== "GET")
    headers["Content-Type"] = binary ? "application/octet-stream" : "application/json";
  if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
  try {
    const response = await fetch(`${BACKEND_BASE_URL}${path}`, {
      method,
      headers,
      body: method === "GET" ? undefined : binary ? body : JSON.stringify(body ?? {}),
    });
    const text = await response.text();
    const result = text ? JSON.parse(text) : {};
    const error =
      typeof result.error === "string"
        ? { message: result.error }
        : result.error ??
          (!response.ok
            ? {
                message: result.message || `Request failed (${response.status})`,
                status: response.status,
              }
            : null);
    return { data: result.data ?? null, error };
  } catch (error: any) {
    return {
      data: null,
      error: { message: error?.message || "Unable to reach the backend server" },
    };
  }
}

export const backendPublicRequest = <T = any>(path: string, body?: unknown | ArrayBuffer) =>
  backendTransportRequest<T>(path, { body });
